<template>
<div>
    <div class="px-5 pt-2">
        <div id="btn-open-caja" class="d-flex justify-content-end pt-1">
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackCampus">
                    <i class="fas fa-recycle"></i> Cambiar de Sede
                </button>
            </div>
        </div>
    </div>
    <div class="px-3 py-3">
        <HistoriasCli :pa="pa"/>
    </div>
</div>
</template>

<script>
import HistoriasCli from "@/components/Paciente/Pages/MedicalAct.vue";
export default {
    data() {
        return {
            pa: 1,
        }
    },
    components: {
        HistoriasCli
    },
    methods: {
        mtdBackCampus: function () {
            this.$emit("mtdBackCampus");
        },
    }
}
</script>
